module.exports = __webpack_public_path__ + "img/Unreal_Logo.1a09077e.svg";